__turbopack_context__.v({
  "badge": "badge-module-scss-module__wTXaeG__badge",
  "badge__gray": "badge-module-scss-module__wTXaeG__badge__gray",
  "badge__green": "badge-module-scss-module__wTXaeG__badge__green",
  "badge__orange": "badge-module-scss-module__wTXaeG__badge__orange",
  "badge__red": "badge-module-scss-module__wTXaeG__badge__red",
  "badge__yellow": "badge-module-scss-module__wTXaeG__badge__yellow",
});
